var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e81b26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d00914"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe633"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-.002933-.001539h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.997067,
    cy: 5.712747,
    mask: "url(#e)",
    r: 1.904762
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6372669 6.08991827 5.3598005.76568579v-2.28571428l-5.3598005.76568579c.0174444.12321561.0264672.24913978.0264672.37717135 0 .12803156-.0090228.25395574-.0264672.37717135zm-5.2803989-.7543427-5.35980055-.76568579v2.28571428l5.35980055-.76568579c-.01744442-.12321561-.02646722-.24913979-.02646722-.37717135 0-.12803157.0090228-.25395574.02646722-.37717135zm3.16327638-2.23821322.61978019-3.09890115h-2.28571426l.61978023 3.09890115c.16914272-.03364018.34404954-.0512821.52307689-.0512821s.35393425.01764192.52307695.0512821zm-1.04615384 5.23076915-.61978023 3.0989011h2.28571426l-.61978019-3.0989011c-.1691427.03364016-.3440496.05128206-.52307695.05128206s-.35393417-.0176419-.52307689-.05128206z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.83025671 7.26745475-6.2416853 4.47847005 1.52944139 1.6986168 5.10648556-5.73949474c-.14688288-.13077673-.27920831-.27755231-.39424165-.43759211zm4.33362149-3.10941566 6.2416853-4.47847004-1.5294414-1.69861675-5.10648553 5.73949468c.14688282.13077672.27920833.2775523.39424163.43759211zm-.39424163 3.54700777 5.10648553 5.73949474 1.5294414-1.6986168-6.2416853-4.47847005c-.1150333.1600398-.24735881.30681538-.39424163.43759211zm-3.54513821-3.98459988-5.10648556-5.73949468-1.52944139 1.69861675 6.2416853 4.47847004c.11503334-.16003981.24735877-.30681539.39424165-.43759211z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/MK.31f4e5be5e565e6377e6e396814abd48.svg";
export { ForwardRef as ReactComponent };